import apiWrapper from './ApiWrapper'

class TermsAndConditionsService {
    handleUserAnswer({ termsAndConditionsAnswer }) {
        return apiWrapper.post('/api/termsAndConditions/handleUserAnswer', { ...termsAndConditionsAnswer })
    }
}

export default new TermsAndConditionsService()